/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Loaded_ToastInputs */



/**
* | output |
* | --- |
* | "Style guide \"{name}\" loaded successfully" |
*
* @param {Iframe_Remote_Style_Guide_Loaded_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_loaded_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Loaded_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Guide de style "${i?.name}" charge avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Styleguide "${i?.name}" erfolgreich geladen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Guida di stile "${i?.name}" caricata correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Руководство по стилю "${i?.name}" успешно загружено`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La guía de estilo "${i?.name}" se cargó correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`样式指南“${i?.name}”已成功加载`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スタイルガイド「${i?.name}」が正常に読み込まれました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्टाइल गाइड "${i?.name}" सफलतापूर्वक लोड हो गई`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O guia de estilo "${i?.name}" foi carregado com sucesso.`)
	return /** @type {LocalizedString} */ (`Style guide "${i?.name}" loaded successfully`)
});